import React from 'react';
import { useSelector } from 'react-redux';

import { Post } from '../../components/Post';
import { findPostRegionName } from './utils';
import { buildPostUrl, isOwner, sanitizePostContent, usePreparedContent } from '../../utils';
import { selectPost } from '../../selectors/post';
import { selectUser } from '../../selectors/user';
import { selectCurrentRegion } from '../../selectors/geo/currentRegion';
import { selectRegions } from '../../selectors/regions/selectRegions';
import { POST_COMMENTS_ID } from '../../constants';
import { ERequestStatus } from '../../types/requestStatus';
import { EStatus, EType } from '../../repositories/journal/entities/journal/JournalAttributesSchema';

export const PostPreviewContainer = () => {
  const post = useSelector(selectPost);
  const user = useSelector(selectUser);
  const currentRegion = useSelector(selectCurrentRegion);
  const { items: dictionaryRegions } = useSelector(selectRegions);

  usePreparedContent();

  if (post.status !== ERequestStatus.Succeed) {
    return null;
  }

  const {
    id,
    attributes: {
      commentsCount,
      datePublish,
      image,
      numViews,
      subtitle,
      title,
      type,
      regions,
      slug,
      updatedAt,
      authorObject,
      authorId,
      content,
      preparedContent,
      status,
      disableComments,
      blockReason,
    },
  } = post;
  const isUserOwner = isOwner(authorId || undefined, (user.isAuthenticated && user.userId) || undefined);

  return (
    <Post
      authorPostsCount={undefined}
      authorId={authorId || undefined}
      authorObject={[EType.Blogs, EType.Questions].includes(type) ? authorObject : undefined}
      commentsCount={commentsCount}
      content={sanitizePostContent(preparedContent || content || '')}
      dateModified={updatedAt}
      datePublished={datePublish}
      image={image}
      numViews={numViews}
      postId={id}
      postUrl={buildPostUrl({ type, slug, id })}
      postCommentsUrl={buildPostUrl({ type, slug, id, anchor: POST_COMMENTS_ID })}
      postRegionName={findPostRegionName({
        globalRegionId: currentRegion.id,
        postRegionIds: regions || [],
        dictionaryRegions,
      })}
      subtitle={[EType.Articles, EType.News].includes(type) ? subtitle : undefined}
      title={title}
      type={type}
      blockReason={
        [EType.Blogs, EType.Questions].includes(type) && isUserOwner && status === EStatus.Decline
          ? blockReason
          : undefined
      }
      canViewComments={!disableComments}
      canPublishPost={[EType.Blogs, EType.Questions].includes(type) && isUserOwner && status === EStatus.Draft}
      canEditPost={[EType.Blogs, EType.Questions].includes(type) && isUserOwner}
    />
  );
};
